<div
  class="absolute h-screen w-screen bg-cover bg-center"
  style="background-image: url('assets/woordkr8/backgrounds/login-background.png')"
></div>

<!-- black background overlay -->
<div class="absolute inset-0 bg-black/50"></div>

<div class="relative grid h-dvh place-items-center">
  <form (ngSubmit)="onSubmit()" [formGroup]="form" class="mx-auto flex w-full max-w-md flex-col items-center justify-center gap-4 px-4">
    <!-- Explanation and manual input -->
    <app-portal-panel class="w-[800px]">
      <div class="flex flex-col gap-5">
        <div class="barlow-regular text-center text-4xl text-white">
          <span> Scan de streepjescode of voer de code handmatig in om het </span> <span class="font-bold">apparaat te activeren.</span>
        </div>
        <div class="flex flex-row items-center gap-4">
          <app-portal-input id="code" class="flex-auto" ngDefaultControl formControlName="code" placeholder="AAAA-0000"></app-portal-input>
          <button [disabled]="form.invalid" appPortalButton class="barlow-regular w-1/7 p-2" type="submit">
            <span class="barlow-regular text-2xl">OK</span>
          </button>
        </div>
        <!-- <app-portal-input id="name" ngDefaultControl formControlName="deviceName" placeholder="Apparaatnaam"></app-portal-input> -->
        <button appPortalButton (click)="scanBarcode()" color="blue" class="barlow-regular p-2 text-2xl" type="button">
          Scan met camera
        </button>
      </div>
    </app-portal-panel>
  </form>
</div>

<!-- back button -->
<button (click)="navigateToSelectDeviceType()" class="absolute top-0 left-4 w-48 transition-transform hover:scale-105" type="button">
  <img src="assets\woordkr8\sprites\back-button.png" class="object-contain" alt="Terug" />
</button>

<!-- Activation success message -->
@if (showSuccessMessage()) {
  <div class="success-overlay absolute inset-0 z-50 flex items-center justify-center bg-black/70">
    <app-portal-panel color="green" class="success-panel max-w-xl min-w-sm">
      <div class="barlow-semi-condensed-bold size-full p-4 text-center text-6xl text-white">Je apparaat is geactiveerd!</div>
    </app-portal-panel>
  </div>
}
